import { Query } from 'acast-reactor';
import request from 'superagent';
import { getUserToken } from 'services/authentication';
import Config from 'app/config';

export function readShowDrafts(showId, options = {}) {
  if (typeof showId !== 'string') {
    throw new Error('Invalid argument, show id must be string');
  }

  return new Promise((resolve, reject) => {
    const API_HOST = Config.get('CREATE_API_HOST');

    request
      .get(`${API_HOST}/api-v3/shows/${showId}/drafts`)
      .query(options)
      .set('Authorization', `Bearer ${getUserToken()}`)
      .end((err, res) => {
        if (err) {
          return reject(err);
        }
        return resolve(res.body);
      });
  });
}

export default Query.define('showdrafts/read', {
  cache: false,
  execute: readShowDrafts,
});
